export default __webpack_public_path__ + "static/media/illustration-mian-m@2x.87a1a185.webp";